const POSITION = {
    NEXT_BUTTON: 'next-button',
    START_POSITION: 'practice-start',
    OK_POSITION: 'practice-stop',
    CLEAR_POSITION: 'practice-clear',
    LETTER_D: 'letter-d',
    LETTER_O: 'letter-o',
    LETTER_G: 'letter-g',
    LETTER_R: 'letter-r',
    LETTER_P: 'letter-p',
    LETTER_A: 'letter-a',
};

export default POSITION;
